/* ======================================================
   ABOUT US — Paw N Hoof
   Scroll Reveal + Parallax
   ====================================================== */
(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Scroll Reveal via IntersectionObserver ──────── */
  var reveals = document.querySelectorAll('.au-reveal');

  if (reveals.length) {
    if ('IntersectionObserver' in window) {
      var revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('au-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.10,
        rootMargin: '0px 0px -48px 0px'
      });

      reveals.forEach(function (el) {
        revealObserver.observe(el);
      });
    } else {
      /* Fallback for older browsers */
      reveals.forEach(function (el) {
        el.classList.add('au-visible');
      });
    }
  }

  /* ── Hero Parallax ───────────────────────────────── */
  if (!prefersReducedMotion) {
    var heroImg = document.querySelector('.au-hero__img');
    var hero    = document.querySelector('.au-hero');

    if (heroImg && hero) {
      var ticking = false;

      function updateParallax() {
        var scrolled    = window.pageYOffset;
        var heroHeight  = hero.offsetHeight;
        if (scrolled < heroHeight) {
          var pct = scrolled / heroHeight;
          heroImg.style.transform = 'scale(1.08) translateY(' + (pct * 32) + 'px)';
        }
        ticking = false;
      }

      window.addEventListener('scroll', function () {
        if (!ticking) {
          window.requestAnimationFrame(updateParallax);
          ticking = true;
        }
      }, { passive: true });
    }
  }

  /* ── Founder Card Hover Depth ────────────────────── */
  if (!prefersReducedMotion) {
    var founderCards = document.querySelectorAll('.au-founder-card');
    founderCards.forEach(function (card) {
      var moveTicking = false;
      card.addEventListener('mousemove', function (e) {
        if (!moveTicking) {
          var ex = e.clientX; var ey = e.clientY;
          window.requestAnimationFrame(function () {
            var rect = card.getBoundingClientRect();
            var cx   = rect.left + rect.width / 2;
            var cy   = rect.top  + rect.height / 2;
            var dx   = (ex - cx) / (rect.width / 2);
            var dy   = (ey - cy) / (rect.height / 2);
            card.style.transform =
              'translateY(-10px) rotateY(' + (dx * 3) + 'deg) rotateX(' + (-dy * 3) + 'deg)';
            moveTicking = false;
          });
          moveTicking = true;
        }
      });

      card.addEventListener('mouseleave', function () {
        card.style.transform = '';
      });
    });
  }

})();
